import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import { FAQS } from "@/lib/data";
import JsonLd from "@/components/JsonLd";
import useSeo from "@/hooks/useSeo";

function Item({ q, a, index }) {
  const [open, setOpen] = useState(index === 0);
  return (
    <div
      className="border-b border-navy/10 py-5"
      data-testid={`faq-item-${index}`}
    >
      <button
        onClick={() => setOpen(!open)}
        data-testid={`faq-toggle-${index}`}
        className="w-full flex items-center justify-between text-left gap-6"
      >
        <span className="font-serif text-xl md:text-2xl text-navy">{q}</span>
        <ChevronDown
          className={`w-5 h-5 text-gold flex-shrink-0 transition ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>
      {open && (
        <p
          data-testid={`faq-answer-${index}`}
          className="mt-4 text-navy/70 leading-relaxed max-w-3xl"
        >
          {a}
        </p>
      )}
    </div>
  );
}

export default function FAQPage() {
  useSeo({
    title: "Frequently Asked Questions",
    description:
      "Common questions about ConnectHER's services, billing, scheduling, and process — answered.",
    path: "/faq",
  });

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <>
      <JsonLd id="jsonld-faq" data={faqSchema} />
      <section className="pt-16 md:pt-24 pb-10" data-testid="faq-hero">
        <div className="container-app max-w-4xl">
          <div className="eyebrow">Resources &amp; FAQ</div>
          <h1 className="mt-3 text-5xl md:text-6xl leading-tight">
            Questions, answered.
          </h1>
          <p className="mt-5 text-lg text-navy/70 max-w-2xl leading-relaxed">
            Common questions about our services, pricing, scheduling, and
            process — answered. Can&apos;t find what you&apos;re looking for?
            Reach out — we love a good question.
          </p>
        </div>
      </section>

      <section className="pb-20" data-testid="faq-list">
        <div className="container-app max-w-4xl">
          {FAQS.map((f, i) => (
            <Item key={i} q={f.q} a={f.a} index={i} />
          ))}
        </div>
      </section>
    </>
  );
}
